import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/greenScreen.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-738b663d"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
    class: "changeStyle",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.changeStyle && _ctx.changeStyle.apply(_ctx, arguments);
    })
  })]);
}